var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinusicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.04688,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 24.0469H16.5C15.95 24.0469 15.5 23.5969 15.5 23.0469C15.5 22.4969 15.95 22.0469 16.5 22.0469H28.5C29.05 22.0469 29.5 22.4969 29.5 23.0469C29.5 23.5969 29.05 24.0469 28.5 24.0469Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 24.0469H16.5C15.95 24.0469 15.5 23.5969 15.5 23.0469C15.5 22.4969 15.95 22.0469 16.5 22.0469H28.5C29.05 22.0469 29.5 22.4969 29.5 23.0469C29.5 23.5969 29.05 24.0469 28.5 24.0469Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 24.0469H16.5C15.95 24.0469 15.5 23.5969 15.5 23.0469C15.5 22.4969 15.95 22.0469 16.5 22.0469H28.5C29.05 22.0469 29.5 22.4969 29.5 23.0469C29.5 23.5969 29.05 24.0469 28.5 24.0469Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 24.0469H16.5C15.95 24.0469 15.5 23.5969 15.5 23.0469C15.5 22.4969 15.95 22.0469 16.5 22.0469H28.5C29.05 22.0469 29.5 22.4969 29.5 23.0469C29.5 23.5969 29.05 24.0469 28.5 24.0469Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 24.0469H16.5C15.95 24.0469 15.5 23.5969 15.5 23.0469C15.5 22.4969 15.95 22.0469 16.5 22.0469H28.5C29.05 22.0469 29.5 22.4969 29.5 23.0469C29.5 23.5969 29.05 24.0469 28.5 24.0469Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 24.0469H16.5C15.95 24.0469 15.5 23.5969 15.5 23.0469C15.5 22.4969 15.95 22.0469 16.5 22.0469H28.5C29.05 22.0469 29.5 22.4969 29.5 23.0469C29.5 23.5969 29.05 24.0469 28.5 24.0469Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 24.0469H16.5C15.95 24.0469 15.5 23.5969 15.5 23.0469C15.5 22.4969 15.95 22.0469 16.5 22.0469H28.5C29.05 22.0469 29.5 22.4969 29.5 23.0469C29.5 23.5969 29.05 24.0469 28.5 24.0469Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5 24.0469H16.5C15.95 24.0469 15.5 23.5969 15.5 23.0469C15.5 22.4969 15.95 22.0469 16.5 22.0469H28.5C29.05 22.0469 29.5 22.4969 29.5 23.0469C29.5 23.5969 29.05 24.0469 28.5 24.0469Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusicon);
export default __webpack_public_path__ + "static/media/minusicon.45fa00fb9d450c7adce625b292405b5a.svg";
export { ForwardRef as ReactComponent };